import React from 'react';
import { TagReads, DishInfo } from '../types/Tags';
import PlateImage from './PlateImage';
import TagBox from './TagBox';
import { getBeltTime, timeToSeen } from '../App';

interface PlateGroupProps {
  dishData: DishInfo;
  plates: TagReads[];
  ourTime: number;
  onClick: () => void;
}

const PlateGroup = ({ dishData, plates, ourTime, onClick }: PlateGroupProps) => {
  const ingredientList = (dishData.ingredients ?? []).join(', ');
  const count = plates.length;

  // Get the next plate to arrive (shortest time to be seen)
  const nextPlate = plates.reduce((closest, current) => {
    const closestTime = timeToSeen(closest.timesSeen, new Date().getTime(), ourTime);
    const currentTime = timeToSeen(current.timesSeen, new Date().getTime(), ourTime);
    return currentTime < closestTime ? current : closest;
  });

  const nextPlateTimePercent = timeToSeen(nextPlate.timesSeen, new Date().getTime(), ourTime) / getBeltTime(nextPlate.timesSeen);

  return (
    <div style={{
      display: 'flex',
      backgroundColor: 'white',
      flexDirection: 'row',
      alignItems: 'center',
      borderTop: '1px solid #E5E7EF',
      padding: '12px',
      cursor: 'pointer'
    }} onClick={onClick}>
      <div style={{
        justifyContent: 'start',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        margin: '15px'
      }}>
        <PlateImage
          color={dishData.color ?? 'red'}
          size={50}
          percent={nextPlateTimePercent}
          dishID={dishData.id}
        />
      </div>
      <div style={{
        flexDirection: 'column',
        display: 'flex',
        flex: 1,
        height: '100%'
      }}>
        <div style={{
          flexDirection: 'row',
          display: 'flex',
          gap: '10px',
          alignItems: 'start',
        }}>
          <p style={{ fontWeight: 'bold', fontSize: '1rem', margin: '0px' }}>{dishData.name}</p>
          <p style={{
            color: '#777',
            margin: '0px',
            backgroundColor: '#f0f0f0',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '0.9rem'
          }}>
            {count} on belt
          </p>
        </div>

        <div style={{
          flexDirection: 'row',
          display: 'flex',
          marginTop: '4px',
          alignItems: 'end',
          color: '#7E8494'
        }}>
          <p>{ingredientList}</p>
        </div>

        <div style={{
          display: 'flex',
          gap: '8px',
          marginTop: '8px'
        }}>
          {(dishData.tags ?? []).map((tag) => {
            return <TagBox tag={tag} key={tag} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default PlateGroup;
